import Loadable from 'components/Loadable';
import { ROLES } from 'models/Roles';
import { IRoute } from 'models/route';
import { lazy } from 'react';

const ListSentences = Loadable(
	lazy(() => import('modules/Sentence/pages/SentencesList')),
);
const AddSentence = Loadable(
	lazy(() => import('modules/Sentence/pages/AddSentence')),
);

const UpdateSentence = Loadable(
	lazy(() => import('modules/Sentence/pages/UpdateSentence')),
);

const SENTENCES_ROUTES: IRoute[] = [
	{
		path: 'sentences',
		element: ListSentences,
		name: 'Sentences',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'sentences/add',
		element: AddSentence,
		name: 'Add Sentence',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'sentences/update/:sentenceId',
		element: UpdateSentence,
		name: 'Add Sentence',
		roles: [ROLES.ADMIN],
		private: true,
	},
];

export default SENTENCES_ROUTES;
